// const authApi = `/api`
// const getApi = `/api/get`
// const postApi = `/api/post`
const api = `/api`
const AUTH = {
    LOGIN: `${api}/boatrack-login`,
    SIGNUP: `${api}/boatrack-signup`,
    RESET_PASSWORD: `${api}/reset-password`,
    FORGOT_PASSWORD: `${api}/forgot-password`,
}

const GET = {
    VERIFY_TOKEN: `${api}/access_token`,
    GET_USERS: `${api}/get-all-boatrack-users`,
    GET_DEVICES: `${api}/get-all-boatrack-devices`,
    GET_DEVICE_LOCATION: `${api}/get-boatrack-serial-number-location`,
    GET_GEOFENCES: `${api}/get-geo-fences`,
    GET_ALL_LOCATION: `${api}/get-map-geo-fece-data-for-bao-track-app`,
    GET_CAMERA_LIVE: `${api}/get-camera-live-stream`,
    GET_DOWNLOAD_DEVICE_PDF: `${api}/download-device-pdf`,
    GET_DOWNLOAD_GEOFENCE_PDF: `${api}/download-geofence-pdf`,
}

const POST = {
    UPDATE_PASSWORD: `${api}/update-boatrack-password`,
    EDIT_USER: `${api}/edit-boatrack-user`,
    UPDATE_PROFILE: `${api}/update-boatrack-user`,
    ADD_USER: `${api}/add-boatrack-user`,
    DELETE_USER: `${api}/delete-boatrack-user`,
    ADD_DEVICE: `${api}/add-boatrack-device`,
    UPDATE_DEVICE: `${api}/edit-boatrack-device`,
    DELETE_DEVICE: `${api}/delete-boatrack-device`,
    ADD_GEOFENCE: `${api}/add-geofence`,
    DELETE_GEOFENCE: `${api}/delete-geofence`,
    UPDATE_GEOFENCE: `${api}/geofence-update`,
    UPLOAD_VEHICLE_LOGO: `${api}/uploadfile`,
    SET_CAMERA_VISIBILITY: `${api}/set-camera-visibility`,
}

export {
    AUTH,
    GET,
    POST
}